import { render, staticRenderFns } from "./formbuilderReworkSucess.vue?vue&type=template&id=233743ee&scoped=true"
import script from "./formbuilderReworkSucess.vue?vue&type=script&lang=js"
export * from "./formbuilderReworkSucess.vue?vue&type=script&lang=js"
import style0 from "./formbuilderReworkSucess.vue?vue&type=style&index=0&id=233743ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233743ee",
  null
  
)

export default component.exports